/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from 'react'
import Link from 'next/link'
import Image from 'components/core/Image'
import styles from './styles.module.scss'
import Store from './Store'

const StoreGridItem = ({ store, permalink, index, storeToShow, setStoreToShow }) => {
  const { images = [], city, name } = store

  const storeElement = useRef<any>()

  const handleClick = () => {
    if (storeToShow === permalink) {
      setStoreToShow(null)
    } else {
      setStoreToShow(permalink)
    }
  }

  useEffect(() => {
    if (storeToShow && storeToShow === permalink && storeElement?.current) {
      storeElement.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [storeElement, storeToShow, permalink])

  return (
    <section className={styles['stores__accordion-container']} id={permalink} ref={storeElement}>
      <Link
        as={permalink ? `/stores/${permalink}` : '/stores'}
        href={{ query: { store: permalink } }}
        shallow
        scroll={false}
        className={styles.stores__link}
        onClick={handleClick}
        tabIndex={index}
        role="link"
      >
        <figure>
          <Image
            height={300}
            width={450}
            src={images[0]?.path}
            containerClassName={styles.stores__image}
            alt={name}
          />
          <figcaption className={styles.stores__caption}>
            <h4 className={styles.stores__city}>{city.toUpperCase()}</h4>
            <h3 className={styles.stores__name}>{name}</h3>
          </figcaption>
        </figure>
      </Link>

      {storeToShow && storeToShow === permalink && (
        <Store {...store} setStoreToShow={setStoreToShow} />
      )}
    </section>
  )
}

export default StoreGridItem
